var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":_vm.loading}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"66","color":_vm.circleColor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }